import { Typography } from '@mui/material'
import React from 'react'

export const FormTopLabel: React.FC<{ required?: boolean, small?: boolean }> = ({ children, required = false, small = false }) => {
  return (
    <Typography className={`form-element-label ${small ? 'small' : ''}`}>
      {children}
      {required && '*'}
    </Typography>
  )
}
